import React from 'react'
import PropTypes from 'prop-types'
import SpeciesDetailsSearchForm from './speciesDetailsSearchForm'


const SpeciesDetails = ({ site, hasCriteriaSummary = false }) => {
  return (
    <SpeciesDetailsSearchForm site={site} hasCriteriaSummary={hasCriteriaSummary} />
  )
}

export default SpeciesDetails

SpeciesDetails.propTypes = {
  site: PropTypes.object.isRequired,
  hasCriteriaSummary: PropTypes.bool
}
